import { render, staticRenderFns } from "./MallSet.vue?vue&type=template&id=2e08ffc5&"
import script from "./MallSet.vue?vue&type=script&lang=js&"
export * from "./MallSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MallSet.vue"
export default component.exports